
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27.53 23.57"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"chevrons-right"}},[_c('g',{attrs:{"id":"Path_358","data-name":"Path 358"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_1849","data-name":"Path 1849","d":"M15.52 22.28a1.75 1.75 0 01-1.75-1.75 1.7 1.7 0 01.51-1.24l7.52-7.52-7.52-7.52a1.75 1.75 0 012.48-2.48l8.75 8.76a1.74 1.74 0 010 2.48l-8.75 8.76a1.8 1.8 0 01-1.24.51z"}})]),_c('g',{attrs:{"id":"Path_359","data-name":"Path 359"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_1850","data-name":"Path 1850","d":"M3.26 22.28a1.75 1.75 0 01-1.24-3l7.52-7.52L2 4.25a1.75 1.75 0 012.5-2.48l8.75 8.76a1.74 1.74 0 010 2.48L4.5 21.77a1.8 1.8 0 01-1.24.51z"}})])])])
          )
        }
      }
    